import { Component, ViewChild, TemplateRef, Input, EventEmitter, Output, OnInit, OnDestroy } from '@angular/core';
import { AppService } from '../../app.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../../support/success-snackbar/success-snackbar.component';
import { messageService } from '../../message.service';
import { MatOption } from '@angular/material/core';
import { qmsService } from '../qms.service';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { MatSelect } from '@angular/material/select';
import { FlexibleFieldsComponent } from '../flexible-fields/flexible-fields.component';

export interface Dependency {
  module: string,
  groupId: any
}
@Component({
  selector: 'app-add-map-capa',
  templateUrl: './add-map-capa.component.html',
  styleUrls: ['./add-map-capa.component.scss']
})


export class AddMapCapaComponent implements OnInit, OnDestroy {

  isProcessing: boolean = false;
  refresh: boolean = false;

  dateCustomClasses: DatepickerDateCustomClasses[];

  dependency: Dependency;

  constructor(
    readonly appService: AppService,
    readonly message: messageService,
    readonly qualityService: qmsService,

    private readonly snackBar: MatSnackBar,
    private readonly dialog: MatDialog,
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  @Input() findings: any;
  @Output() valueEmitter = new EventEmitter<string>();


  capaDetails: any = [];
  capa: any = {};

  groupList: any = [];
  departmentList: any = [];
  ownerList: any = [];
  typeList: any = [];
  requestedAtList: any = [];
  businessAreaList: any = [];
  reasonForCapaList: any = [];

  groupDropDown: any = [];
  departmentDropDown: any = [];
  ownerDropDown: any = [];
  typeDropDown: any = [];
  requestedAtDropDown: any = [];
  businessAreaDropDown: any = [];
  reasonForCapaDropDown: any = [];

  group: any = null;
  department: any = null;

  groupSearchText: string = '';
  departmentSearchText: string = '';
  ownerSearchText: string = '';
  typeSearchText: string = '';
  requestedAtSearchText: string = '';
  businessAreaSearchText: string = '';
  reasonForCapaSearchText: string = '';

  selectedBusinessArea: any = [];
  selectedReasonForCapa: any = [];

  snackbarRef: any;
  popupTitle: string = '';

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.isProcessing = true;

    this.selectedTabName = 'Create CAPA';
    this.dependency = { module: 'CAPA', groupId: null };

    this.departmentList = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');

    this.selectBoxForDepartment();
    this.selectBoxForType();

    this.appService.getGroupsModuleCurrentUserVw("CAPA").subscribe((group: any) => {
      this.groupList = group;
      this.selectBoxForGroup();
      this.isProcessing = false;
    })

    this.appService.getAllQmsBusinessAreas().subscribe((business: any) => {
      this.requestedAtList = business;
      this.selectBoxForRequestedAt();
    })

    this.appService.getCodeListsByGroup('REASON_FOR_CAPA').subscribe((reason: any) => {
      this.reasonForCapaList = reason;
      this.selectBoxForReasonForCapa();
    })

  }

  selectBoxForGroup() {
    this.groupDropDown = this.groupList?.map((group: any) => ({
      valueExp: group.groupId,
      displayExp: group.groupName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  groupDetails: any;
  onGroupSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.dependency.module = 'CAPA';
        this.refresh = false;
        this.isProcessing = true;
        this.appService.getQmsGroupDetailsByModule(item.valueExp, 'CAPA').subscribe((groupDetail: any) => {
          this.appService.getQmsActiveGroupUsers(item.valueExp, 'CAPA', 'Owner').subscribe((owner: any) => {
            this.appService.getTypeSettingsByGrpIdGrpDetailId(item.valueExp, groupDetail.groupDetailId).subscribe((response: any) => {
              this.groupDetails = groupDetail;
              this.typeList = response;
              this.ownerList = owner;
              this.selectBoxForOwner();
              this.selectBoxForType();
              this.dynamicLabelCall();
              this.isProcessing = false;
            })
          })
        })
      }
    }
    if (this.loggedInModule == 'AU') {
      this.capa.capaDescription = this.findings;
    } else {
      this.capa.capaDescription = '';
    }
  }

  selectBoxForDepartment() {
    this.departmentDropDown = this.departmentList?.map((dept: any) => ({
      valueExp: dept.codelistCode,
      displayExp: dept.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  onDepartmentSelect(event: any, item: any) {

  }

  selectBoxForOwner() {
    this.ownerDropDown = this.ownerList?.map((owner: any) => ({
      valueExp: owner.userId,
      displayExp: owner.userName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }


  onOwnerSelect(event: any, item: any) {

  }

  selectBoxForType() {
    this.typeDropDown = this.typeList?.map((type: any) => ({
      valueExp: type?.type,
      displayExp: type?.type
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  onCapaTypeSelect(event: any, item: any) {

  }


  selectBoxForRequestedAt() {
    this.requestedAtDropDown = this.requestedAtList?.filter((data: any) => data.module === 'CAPA')?.map((item: any) => ({
      valueExp: item.taskRequestedAt,
      displayExp: item.taskRequestedAt
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  isBusinessAreaEmpty: boolean = false;
  businessAreaName: string = '';
  @ViewChild('flexible', { static: false }) flexibleComponent!: FlexibleFieldsComponent;
  onRequestedAtSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('requested-at', item);
      if (item) {
        this.businessAreaName = item.displayExp;

        const list = this.requestedAtList?.filter((data: any) => data.module === 'CAPA')?.find((task: any) => task.taskRequestedAt == item.displayExp);
        this.isBusinessAreaEmpty = list ? !list.listOfBusinessArea : true;
        [this.businessAreaDropDown, this.selectedBusinessArea] = [[], this.isBusinessAreaEmpty ? '' : []];

        if (!this.isBusinessAreaEmpty) {
          this.isAllBusinessAreaSelected = false;
          this.businessAreaList = list.listOfBusinessArea.split(',');
          this.selectBoxForBusinessArea();
        }
      }
      setTimeout(() => { this.flexibleComponent.triggerFromRequestedAt(item.valueExp) })

    }
  }

  selectBoxForBusinessArea() {
    this.businessAreaDropDown = this.businessAreaList?.map((value: any) => ({
      valueExp: value,
      displayExp: value
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  onBusinessAreaSelect(event: any, item: any) {

  }

  selectBoxForReasonForCapa() {
    this.reasonForCapaDropDown = this.reasonForCapaList?.map((reason: any) => ({
      valueExp: reason?.codelistCode,
      displayExp: reason?.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  visibleReasonForCapaIfOthers: boolean = false;
  onReasonForCapaSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.visibleReasonForCapaIfOthers = item.valueExp?.toLowerCase() == 'others';
      } else {
        this.visibleReasonForCapaIfOthers = false;
      }
      setTimeout(() => {
        this.handleDropDownValidation('reason-for-capa', this.selectedReasonForCapa);
        this.isAllCapaReasonSelected = this.reasonForCapaDropDown.length == this.selectedReasonForCapa.length;
        this.visibleReasonForCapaIfOthers = this.isAllCapaReasonSelected;
      })
    }
  }

  @ViewChild('businessArea') businessArea: MatSelect;
  isAllBusinessAreaSelected = false;
  @ViewChild('reasonForCapa') reasonForCapa: MatSelect;
  isAllCapaReasonSelected = false;

  toggleAllSelection(value: any) {
    if (value == 'businessArea') {
      if (this.isAllBusinessAreaSelected) {
        this.businessArea.options.forEach((item: MatOption) => item.select());
      } else {
        this.businessArea.options.forEach((item: MatOption) => item.deselect());
      }
    } else if (value == 'reasonForCapa') {
      if (this.isAllCapaReasonSelected) {
        this.reasonForCapa.options.forEach((item: MatOption) => item.select());
      } else {
        this.reasonForCapa.options.forEach((item: MatOption) => item.deselect());
      }
      this.visibleReasonForCapaIfOthers = this.isAllCapaReasonSelected;
    }
  }

  limitCharacters(event: Event, field: any) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    let charLimit: any = null;

    const fieldMapping: Record<number, string[]> = {
      1000: ['REASON_FOR_CHANGE', 'REQUESTED_AT']
    };

    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = limit;
        break;
      }
    }

    if (textLength > charLimit) {
      this.showSnackBar("Maximum " + charLimit + " Characters!", 'E');
      target.value = target.value.substring(0, charLimit);
    }
  }

  loggedInModule: string = '';
  openPopup() {
    this.ngOnInit();
    this.capa = {};
    this.pickedCapaDetails = null;
    this.group = null;
    this.loggedInModule = this.qualityService.moduleName;
    this.qualityService.moduleName = 'CAPA';
    if (this.loggedInModule == 'AU') {
      this.capa.capaDescription = this.findings;
    } else {
      this.capa.capaDescription = '';
    }
    this.visibleCapaPopup = this.dialog.open(this.capaPopup, this.capaPopupConfig);
  }

  @ViewChild('angularEditor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  excludeButtons: EditorConfig = {
    buttons: [],
  };

  includeButtons: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  editorTitle: any;
  editorValue: any;
  openEditor(value: string) {

    const formattedValue = value
      .split(' ')
      .map((word, index) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');

    this.editorValue = this.capa[formattedValue] ?? '';
    this.editorTitle = value;
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  okAngularEditorData(editorValue: any) {
    const formattedTitle = this.editorTitle
      .split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');

    this.capa[formattedTitle] = this.editorValue;
    this.visibleEditor.close();
  }

  cancelEditor() {
    this.visibleEditor.close();
  };


  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'initial-complaint-category-validation' || fieldId === 'final-complaint-category-validation');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';

  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  expectedToBeStartedOnConfig = {
    ...this.commonDateConfig,
    minDate: new Date()
  }

  onExpectedToBeStartedOnChange() {
    if (this.capa.expcetedClosureOn && (this.capa.expcetedClosureOn < this.capa.expectedToBeStartedOn)) this.capa.expcetedClosureOn = null;
  }

  generateExpectedClosureDateConfig() {
    return {
      ...this.commonDateConfig,
      minDate: this.capa.expectedToBeStartedOn ? new Date(this.capa.expectedToBeStartedOn) : new Date()
    }
  }

  dynamicLabel: any = null;
  dynamicLabelCall() {
    this.isProcessing = true;

    const data = {
      tableName: 'QMS_CAPA_GRID_VW',
      moduleName: 'CAPA',
      gridName: 'CAPA',
      groupId: this.group,
      forLabel: "Y"
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        let label = labelResponse;
        this.dynamicLabel = label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          return acc;
        }, {});

        this.dependency = { ...this.dependency, groupId: this.group };
        this.refresh = true;
        setTimeout(() => this.flexibleComponent.main());
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  searchCapa() {
    if (this.group) {
      const obj = {
        groupId: this.group + '',
        deptCode: this.department ?? null,
      }

      this.isProcessing = true;
      this.appService.searchCapa(obj).subscribe((response: any) => {
        this.capaDetails = response;
        this.isProcessing = false;
      })
    } else {
      const groupId = document.getElementById("group-validation") as HTMLInputElement;
      groupId && (groupId.style.color = 'red');

      this.showSnackBar("Please select the Group!", 'E');
    }
  }

  reset() {
    this.group = null;
    this.department = null;
    this.capaDetails = [];
  }

  closeCapaPopup() {
    this.qualityService.moduleName = this.loggedInModule;
    this.visibleCapaPopup.close();
  }

  selectedTabName: any;
  onTabClick(event: any) {
    this.selectedTabName = event.tab.textLabel
    if (event.tab.textLabel == "Map CAPA") {
      this.selectedTabName = event.tab.textLabel;
    } else {
      this.group = null;
      this.department = null;
      this.capaDetails = [];
      this.selectedTabName = event.tab.textLabel;
    }
  }

  @ViewChild('capaPopup', { static: true }) capaPopup: TemplateRef<any>;
  visibleCapaPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;

  capaPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  closeMandatoryPopup() {
    this.visibleMandatoryPopup.close();
  }

  pickedCapaDetails: any = null;
  onChildChecked(event: any, capa: any, index: any) {

    this.capaDetails.every((item: any) => { if (item.childCheckBox) { item.childCheckBox = false; } return true; })

    if (event.target.checked) {
      capa.childCheckBox = true;
      this.pickedCapaDetails = capa;
    } else {
      this.pickedCapaDetails = null;
    }
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;

      element && (element.style.color = 'red');
      !element && console.error('Unable to find the element. [fieldValidation()] Id → ', elementId);
    });
  }

  createCapa(capa: any) {

    if (this.selectedTabName == 'Create CAPA') {

      const validations = [
        { condition: !this.group, id: 'group' },
        { condition: !capa.deptCode && this.dynamicLabel['DEPT_NAME'].isRemovable != 'Y', id: 'department' },
        { condition: !capa.owner, id: 'owner' },
        { condition: !capa.capaType, id: 'type' },
        { condition: !capa.requestedAt, id: 'requested-at' },
        { condition: !this.selectedBusinessArea.length && !capa.requestedAt, id: 'business-area' },
        { condition: !capa.expectedToBeStartedOn && this.dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable != 'Y', id: 'expected-started-on' },
        { condition: !capa.expcetedClosureOn, id: 'expected-closure-on' },
        { condition: !capa.shortDescription, id: 'short-description' },
        { condition: !capa.capaDescription, id: 'description' },
        { condition: !this.selectedReasonForCapa.length && this.dynamicLabel['REASON_FOR_CAPA_CODE'].isRemovable != 'Y', id: 'reason-for-capa' },
        { condition: !capa.reasonForCapa && this.visibleReasonForCapaIfOthers && this.dynamicLabel['REASON_FOR_CAPA_CODE'].isRemovable != 'Y', id: 'visible-if-others' }
      ];

      const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

      if (invalidIds.length > 0) {
        this.fieldValidation(invalidIds);
        this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
      } else {
        this.isProcessing = true;
        this.prepareJson(capa);

      }
    } else {
      this.message.addMapCapaComponentDetails = { capaID: this.pickedCapaDetails.capaId, shortDescription: this.pickedCapaDetails.shortDescription };
      this.message.addMapCapaFindings = {
        capaNo: this.pickedCapaDetails.capaNo,
        capaId: this.pickedCapaDetails.capaId,
        status: this.pickedCapaDetails.status ?? 'Draft'
      };

      this.isProcessing = false;
      this.valueEmitter.emit();
      this.closeCapaPopup();
    }
  }

  prepareJson(capa: any) {
    const data = {
      groupId: this.group,
      ...this.dynamicLabel['DEPT_NAME'].isRemovable != 'Y' && { deptCode: capa.deptCode },
      owner: capa.owner,
      capaType: capa.capaType,
      requestedAt: capa.requestedAt,
      coreBusinessAreaName: this.businessAreaDropDown.length ? this.selectedBusinessArea.join(',') : capa.coreBusinessAreaName,
      reasonForCapa: capa.reasonForCapa ?? null,
      ...this.dynamicLabel['REASON_FOR_CAPA_CODE'].isRemovable != 'Y' && { reasonForCapaCode: this.selectedReasonForCapa.join(',') },
      expcetedClosureOn: new Date(capa.expcetedClosureOn),
      ...this.dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable != 'Y' && { expectedToBeStartedOn: new Date(capa.expectedToBeStartedOn) },
      effectivenessCheckReqd: capa.effectivenessCheckReqd ? "Y" : "N",
      isRiskCalculationReqd: capa.isRiskCalculationReqd ? "Y" : "N",
      shortDescription: capa.shortDescription,
      capaDescription: capa.capaDescription
    }

    this.appService.createCapa(data).subscribe({
      next: (Response: any) => {
        if (Response.resultType == 'S' && this.message.isFromFindings) {
          this.getCapaDetails(Response);
          this.message.isFromFindings = false;
        } else if (Response.resultType == 'S' && !this.message.isFromFindings) {
          this.message.addMapCapaComponentDetails = { capaID: Response.ID, shortDescription: capa.shortDescription };
          this.closeCapaPopup();
          this.valueEmitter.emit();
          this.isProcessing = false;
        } else {
          this.isProcessing = false;
        }
        this.showSnackBar(Response.result, Response.resultType);
      }
    });
  }

  private getCapaDetails(response: any): void {
    this.appService.getCapaVwDetailsByCapaNo(
      response.ID,
    ).subscribe((data: any) => {

      this.message.addMapCapaFindings = { capaNo: response.ID, capaId: data.capaId, status: data.status };

      this.isProcessing = false;
      this.closeCapaPopup();
      this.valueEmitter.emit();
    });
  }


  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

}
